export const sessionTypes = [
  { value: 'Free', label: 'Free' },
  { value: 'Paid', label: 'Paid' },
  { value: 'One-on-One', label: 'One-on-One' },
  { value: 'Group', label: 'Group' },
];


